import { render, staticRenderFns } from "./GWASSummaryStatistics.vue?vue&type=template&id=d032e51a&scoped=true&"
import script from "./GWASSummaryStatistics.vue?vue&type=script&lang=js&"
export * from "./GWASSummaryStatistics.vue?vue&type=script&lang=js&"
import style0 from "./GWASSummaryStatistics.vue?vue&type=style&index=0&id=d032e51a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d032e51a",
  null
  
)

export default component.exports